// @ts-check
import { z } from 'zod';

import Timestamp from '@/store/modules/models/global/Timestamp';
import UserSummary from '@/store/modules/users/models/UserSummary';

const Group = z.object({
  id: z.number(),
  name: z.string(),
  created_at: Timestamp,
  created_by: UserSummary.shape.name.nullable(),
  users_count: z.number().nullable(),
});

export default Group;
